import { ComponentProps } from "react";
import { Button } from "../../button";
import "./no-account-found.scss";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../../utils/translation";

export interface NoAccountFoundProps extends ComponentProps<"div"> {
  onButtonClick: () => void;
  buttonText?: string;
}

export function NoAccountFound({
  onButtonClick,
  buttonText,
  ...props
}: NoAccountFoundProps) {
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);

  return (
    <div className="no-account-found-modal modal-content" {...props}>
      <div className="top-area">
        <div className="title">
          {checkTranslationKey(
            translations[lang]?.No_account_found,
            "No account found!"
          )}
        </div>
        <div className="message-icon">
          <img src="../img/icns/no-account.png" alt="" width="80em" />
        </div>
        <div className="message">
          {checkTranslationKey(
            translations[lang]
              ?.There_is_no_account_related_to_this_phone_number,
            "There is no account related to this phone number. Subscribe now to access premium content."
          )}
        </div>
      </div>
      <div className="bottom-area">
        <Button onClick={onButtonClick} buttonType="success">
          {buttonText ||
            checkTranslationKey(translations[lang]?.Sign_up, "Sign up")}
        </Button>
      </div>
    </div>
  );
}

export default NoAccountFound;
